// extracted by mini-css-extract-plugin
export default {"Link":"ParanodeTableLink_Link__gq3tY"};